// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Ocultar el cursor del sistema en todo el documento */
* {
  cursor: none !important;
}

.cursor {
  position: absolute;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: rgba(255, 0, 0, 0.9);
  opacity: 0.8;
  pointer-events: none;
  transform: translate(-50%, -50%);
  transition: transform 0.1s ease, background-color 0.2s ease, border-color 0.2s ease, opacity 0.2s ease;
  z-index: 9999;
}

.cursor.click {
  transform: scale(0.8);
}

.interactive {
  background-color: rgba(255, 0, 0, 0.35) !important;
}

@media (max-width: 768px) {
  .cursor,
  .cursor.click,
  .interactive {
    transition: none;
    transform: none;
    background-color: transparent !important;
  }
}
  `, "",{"version":3,"sources":["webpack://./src/styles/CustomCursor.css"],"names":[],"mappings":"AAAA,uDAAuD;AACvD;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sCAAsC;EACtC,YAAY;EACZ,oBAAoB;EACpB,gCAAgC;EAChC,sGAAsG;EACtG,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE;;;IAGE,gBAAgB;IAChB,eAAe;IACf,wCAAwC;EAC1C;AACF","sourcesContent":["/* Ocultar el cursor del sistema en todo el documento */\n* {\n  cursor: none !important;\n}\n\n.cursor {\n  position: absolute;\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  background-color: rgba(255, 0, 0, 0.9);\n  opacity: 0.8;\n  pointer-events: none;\n  transform: translate(-50%, -50%);\n  transition: transform 0.1s ease, background-color 0.2s ease, border-color 0.2s ease, opacity 0.2s ease;\n  z-index: 9999;\n}\n\n.cursor.click {\n  transform: scale(0.8);\n}\n\n.interactive {\n  background-color: rgba(255, 0, 0, 0.35) !important;\n}\n\n@media (max-width: 768px) {\n  .cursor,\n  .cursor.click,\n  .interactive {\n    transition: none;\n    transform: none;\n    background-color: transparent !important;\n  }\n}\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
